import { Component, Injector, Output, EventEmitter, ViewChild } from '@angular/core';

import { DxPopupComponent, DxFormComponent } from 'devextreme-angular';
import { KmmNgBackendService } from 'kmm-ng-backend';
import { FormField } from 'kmm-dx-form';

@Component({
   selector: 'app-dynamic-filter',
   templateUrl: './dynamic-filter.component.html'
})
export class DynamicFilterComponent {

   public static NAME: string = 'dynamic_filter-form';

   @ViewChild('popup', { static: true }) popup: DxPopupComponent;
   @ViewChild('dxForm', { static: true }) dxForm: DxFormComponent;

   @Output() filterEvent: EventEmitter<any> = new EventEmitter();
   @Output() filterReady: EventEmitter<any> = new EventEmitter();

   dataModel: Object = {};
   title: string = 'Filtro';
   visible: boolean = false;
   formItems: any;
   submit: any;
   originalItems: any;
   redefine: boolean = false;
   firstRun: boolean = true;
   resetParams: boolean = false;
   hasDefault: boolean = false;

   constructor(
      protected _appService: KmmNgBackendService,
      protected _injector: Injector
   ) {
   }

   popupClose(ev) {
   }

   setItems(items) {
      if (this.redefine) {
         this.assemblyForm(items);

         this.redefine = false;

      } else {
         if (this.firstRun) {
            this.originalItems = items;

            this.assemblyForm(items);

            this.firstRun = false;
         }
      }
   }

   assemblyForm(items) {
      try {
         const formFields = this.buildItems(items);

         let addButton = true;
         formFields.forEach(item => {
            if ('itemType' in item) {
               if (item.itemType === 'button') {
                  addButton = false;
               }
            }
         });

         if (addButton) {
            formFields.push({
               itemType: 'button', horizontalAlignment: 'left', colSpan: 1, buttonOptions: {
                  text: 'Redefinir',
                  type: 'default',
                  onClick: this.resetFilter
               }
            });

            formFields.push({
               itemType: 'button', horizontalAlignment: 'left', colSpan: 2, buttonOptions: {
                  text: 'Filtrar',
                  type: 'success',
                  onClick: this.submitFilter
               }
            });
         }

         this.formItems = [
            FormField.Group('', formFields, 12, 12)
         ];

         this.popup.instance.repaint();
      } catch (ex) {
         console.log(ex);
      }
   }

   buildItems(filtro): Array<any> {
      try {
         this.submit = filtro.submit;

         if ('datasource' in filtro) {
            const keys = Object.keys(filtro.datasource);

            keys.forEach(item => {
               if ('root' in filtro.datasource[item]) {
                  filtro.items.forEach(itemFiltro => {
                     if (itemFiltro.dataField === item) {
                        Object.assign(itemFiltro.editorOptions, {
                           dataSource: filtro.datasource[item].root[filtro.datasource[item].root.header.resultset]
                        });
                     }
                  });
               } else if (typeof filtro.datasource[item] === 'object') {
                  const key = Object.keys(filtro.datasource[item]);

                  if (key.length > 1) {
                     filtro.items.forEach(itemFiltro => {
                        if (itemFiltro.dataField === item) {
                           Object.assign(itemFiltro.editorOptions, {
                              dataSource: filtro.datasource[item]
                           });
                        }
                     });
                  } else {
                     filtro.items.forEach(itemFiltro => {
                        if (itemFiltro.dataField === item) {
                           Object.assign(itemFiltro.editorOptions, {
                              dataSource: filtro.datasource[item][key[0]]
                           });
                        }
                     });
                  }
               } else {
                  filtro.items.forEach(itemFiltro => {
                     if (itemFiltro.dataField === item) {
                        Object.assign(itemFiltro.editorOptions, {
                           dataSource: filtro.datasource[item]
                        });
                     }
                  });
               }
            });
         }

         filtro.items.forEach(item => {
            if (item.editorType === 'dxAutocomplete') {
               Object.assign(item, FormField.Autocomplete3(this._injector, {
                  dataField: item.dataField, colSpan: item.colSpan, label: {
                     text: item.label.text
                  }, editorOptions: { valueExpr: item.editorOptions.valueExpr, showClearButton: true }
               }, this, item.model_field !== '' ? item.model_field : item.datafield_id,
                  item.model.search_param, item.model, item.datafield_id, item.model
               ));
            }
         });

         if (filtro.model) {
            const modelKeys = Object.keys(filtro.model);

            modelKeys.forEach(item => {
               if (isNaN(filtro.model[item]) && typeof filtro.model[item] !== 'object') {
                  if (filtro.model[item].match(/^(\d{4})\-(\d{2})\-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/)) {
                     Object.assign(filtro.model, {
                        [item]: new Date(filtro.model[item].replace(' ', 'T'))
                     });
                  }
               }
            });

            Object.assign(this.dataModel, filtro.model);

            this.hasDefault = true;

            if (this.firstRun) {
               this.filterReady.emit(this.dataModel);
            }
         }
      } catch (ex) {
         console.log(ex);
      }

      return filtro.items;
   }

   resetFilter = (e) => {
      this.redefine = true;
      this.dxForm.instance.resetValues();
      this.dataModel = {};
      this.setItems(this.originalItems);
      this.resetParams = true;
   }

   submitFilter = (e) => {
      // const keys = Object.keys(this.dataModel);

      // keys.forEach(key => {
      //    console.log(key, typeof this.dataModel[key]);

      //    switch (typeof this.dataModel[key]) {
      //       case 'object':
      //          if (!this.dataModel[key]) {
      //             delete this.dataModel[key];
      //          }

      //          break;
      //       case 'string':
      //          if (this.dataModel[key].trim() === '') {
      //             delete this.dataModel[key];
      //          }

      //          break;
      //    }
      // });

      this.filterEvent.emit({ submit: this.submit, params: this.dataModel, reset: this.resetParams });
   }

}
